
import { Component, Vue } from "vue-property-decorator";
import TableChars from "../components/table-chars.vue";
import ExamList from "@/lib/model/exam/exam";
import Auth from "@/lib/common/auth";
import CandidateTable from "../components/candidate-table.vue";
import CandidateSelect from "../components/candidate-select.vue";
import AddCandidate from "../components/add-candidate.vue";
import examLink from "../components/exam-link.vue";
import AddOneCandidateModal from "../components/add-candidate.vue";
import AddMoreCandidateModal from "../components/add-candidates.vue";
import ConfirmDialog from "../components/delete-dialog.vue";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import track from "@/lib/common/track";
import Template from "@/views/ai-builder/components/template.vue";
import {
  ExamAllList,
  ExamAllSearch
} from "@/lib/model/exambuilder/exam-component/exam-list";
import {
  CandidateCreateMore,
  CandidateCreateOne,
  CandidateItem,
  CandidateList,
  CandidateSearch
} from "@/lib/model/exambuilder/exam-component/candidate";
import {
  CandidateCount,
  CandidateCountSearch
} from "@/lib/model/exambuilder/exam-component/statistics";

@Component({
  components: {
    Template,
    AddOneCandidateModal,
    CandidateTable,
    CandidateItem,
    TableChars,
    CandidateSelect,
    AddCandidate,
    examLink,
    AddMoreCandidateModal,
    ConfirmDialog
  }
})
export default class CandidateListV3 extends Vue {
  async created() {
    this.getAllExam();
    await this.getCandidateList();
  }

  mounted() {
    this.candidateCount();
  }

  // 全部面试
  activeExamItem: any = {
    examId: "",
    name: ""
  };
  examAllList = new ExamAllList();

  getAllExam() {
    const params = new ExamAllSearch().assign({ returnAll: true });
    ExamAllList.getList(params).then(res => {
      this.examAllList = new ExamAllList().assign(res);
    });
  }

  examChange(examItem: any) {
    this.candidateCount(examItem.examId);
    this.searchForm.examId = examItem.examId;
    this.activeExamItem = examItem;
    this.searchForm.page = 1;
    this.getCandidateList();
    (this.$refs.tableRef as any).handleClearSelected();
  }

  // 筛选相关
  loadingList = true;
  searchForm = new CandidateSearch().assign({
    companyId: Number(Auth.companyId)
  });
  data: CandidateItem[] = [];
  total = 0;

  async getCandidateList() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.loadingList = true;
    const res = await CandidateList.getList(this.searchForm);
    this.data = res.list;
    this.total = res.count;
    this.loadingList = false;
  }

  // 快速搜索
  handleQuickSearch({ type, row }: { type: string; row: CandidateItem }) {
    this.searchForm.page = 1;

    if (type === "repeatExam") {
      this.searchForm.examId = row.examId;
      this.searchForm.submitStatusList = [];
      this.searchForm.searchKey = row.phone;
      this.activeExamItem.examId = row.examId;
      this.activeExamItem.name = row.examName;
      this.candidateCount(row.examId);
      this.getCandidateList();
    }

    if (type === "repeatCompany") {
      this.searchForm.examId = 0;
      this.searchForm.submitStatusList = [];
      this.searchForm.searchKey = row.phone;
      this.activeExamItem.examId = 0;
      this.activeExamItem.name = "";
      this.candidateCount();
      this.getCandidateList();
    }
  }

  handleRefresh() {
    this.candidateCount();
    this.getCandidateList();
  }

  examSubmitStatusChange(value: number) {
    if (value === -1) {
      this.searchForm.submitStatusList = [];
    } else {
      this.searchForm.submitStatusList = [value];
    }
    this.searchForm.page = 1;
    this.getCandidateList();
    this.candidateCount(this.searchForm.examId);
  }

  // 统计
  headerLoading = false;
  candidateCountInfo = new CandidateCount();
  recommendList: number[] = [];

  async candidateCount(examId = 0) {
    try {
      this.headerLoading = true;
      const params = new CandidateCountSearch().assign({ examId });
      this.candidateCountInfo = await CandidateCount.get(params);
      const { finish } = this.candidateCountInfo;

      this.recommendList = [
        finish.aiRecommendStatusVeryRecommend,
        finish.aiRecommendStatusRecommend,
        finish.aiRecommendStatusNormal,
        finish.aiRecommendStatusNotRecommend
      ];

      this.headerLoading = false;
      this.$nextTick(() => {
        const ref = this.$refs.TableChars as any;
        ref.updateOption();
      });
    } catch (error) {
      this.headerLoading = false;
      console.log("统计", error);
    }
  }

  // 操作
  showDialog(scenes: string) {
    if (scenes === "link") {
      this.showExamLink = true;
      return;
    }

    if (scenes === "addCandidate") {
      return this.showAddCandidate("one");
    }

    if (scenes === "addCandidates") {
      return this.showAddCandidate("more");
    }

    if (scenes === "export") {
      return this.exportDo();
    }
  }

  // 公开邀请
  showExamLink = false;

  closeExamLink() {
    this.showExamLink = false;
    this.getCandidateList();
  }

  // 邀请一位候选人
  isShowAddOne = false;
  isShowAddMore = false;

  candidateCreateOne = new CandidateCreateOne();
  candidateCreateMore = new CandidateCreateMore();

  showAddCandidate(key: string) {
    if (key === "one") {
      this.candidateCreateOne.examId = this.activeExamItem.examId;
      this.isShowAddMore = false;
      this.isShowAddOne = true;
    } else if (key === "more") {
      this.candidateCreateMore.examId = this.activeExamItem.examId;
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }

  closeAddOneCandidate() {
    this.isShowAddOne = false;
    this.getCandidateList();
  }

  closeAddMoreCandidate() {
    this.isShowAddMore = false;
    this.getCandidateList();
  }

  // 确认框
  sureDialog = false;
  sureDialogTitle = "";
  sureDialogShowText = "";
  sureDialogCancelText = "";
  sureDialogOkText = "";
  exportAllCandidateListForm = new CandidateListForm();
  dialogOfExport = false;

  exportDo() {
    this.sureDialogTitle = "导出数据";
    this.sureDialogShowText = `${this.total}条候选人作答相关数据，需等待一定时间，是否导出？`;
    this.sureDialogCancelText = "取消";
    this.sureDialogOkText = "确认";
    this.sureDialog = true;
    this.dialogOfExport = true;
  }

  dialogOfExportCasePage = false;

  sureDialogOk() {
    // 导出确认事件
    if (this.dialogOfExport) {
      this.sureDialogCancel();

      this.loadingList = true;

      CandidateList.export(this.searchForm)
        .then(res => {
          if (res.code !== 0) return;

          this.loadingList = false;
          this.sureDialogTitle = "提示";
          this.sureDialogShowText =
            "导出任务创建成功，请在导出任务页查看进度或下载导出结果";
          this.sureDialogCancelText = "关闭";
          this.sureDialogOkText = "查看";
          this.sureDialog = true;
          this.dialogOfExportCasePage = true;
        })
        .finally(() => {
          this.loadingList = false;
        });
    }

    // 查看异步任务列表事件
    if (this.dialogOfExportCasePage) {
      this.sureDialogCancel();
      this.$router.push({
        path: "/export-component/list"
      });
    }
  }

  sureDialogCancel() {
    this.sureDialog = false;
    this.dialogOfExport = false;
    this.dialogOfExportCasePage = false;
  }
}
